import React from "react";
import { FormCompany } from "./FormCompany";
import { useGetCompanyIdQuery } from "../../api/admin/adminCompany";
import { useParams } from "react-router-dom";

const SchedaCompany = () => {
  const params = useParams();
  const { data: companyDetails } = useGetCompanyIdQuery(params.id, {});

  return (
    <FormCompany
      isEdit={true}
      companyToEdit={companyDetails?.Data}
      userData={companyDetails?.Data?.users}
    />
  );
};

export default SchedaCompany;
